import { useCallback } from 'react'
import { SearchList01Icon } from '@hugeicons/core-solid-rounded'
import { useLingui } from '@lingui/react/macro'
import { useLocation } from 'wouter'

import Input from '@/components/ui/Input'
import GuestTable from './GuestTable'
import useGuestTable from '../hooks/useGuestTable'
import CreateGuestButton from './CreateGuestButton'
import { GraphQL } from '@guestgoodie/graphql'
import { Permission, useCheckPermission } from '@/features/auth'
import { useIsConnected } from '@/features/pms'

export function Guests() {
  const { t } = useLingui()
  const [, navigate] = useLocation()

  const isConnected = useIsConnected()
  const hasPermissionToCreate = useCheckPermission([Permission.GUEST_CREATE])
  const canCreate = !isConnected && hasPermissionToCreate

  const { queryVariables, search, setSearch } = useGuestTable([])

  const onSelect = useCallback(
    (guest: GraphQL.GuestFragmentFragment) => {
      navigate(`/guest/${guest.token}`)
    },
    [navigate]
  )

  return (
    <div>
      <div className="flex flex-col md:flex-row gap-2.5 pb-6 pt-1 items-start md:items-center">
        {canCreate && <CreateGuestButton search={search} />}
        <Input
          Icon={SearchList01Icon}
          placeholder={t`Search…`}
          value={search}
          onChange={event => setSearch(event.target.value)}
        />
      </div>
      <div className="relative w-full rounded bg-white p-5 flex-1 overflow-hidden flex flex-col">
        <div className="size-full overflow-y-auto inset-0">
          <GuestTable
            variables={queryVariables}
            onSelect={onSelect}
            selectedIds={[]}
            showHeading
          />
        </div>
      </div>
    </div>
  )
}
